import React from 'react';
import navarrow from "../assets/back_btn.png";
import {REDEEM_INFO} from "../Strings";
import {staticWebUrl} from '../ApiConstants.js';
import { createAdminPageURL, createOEMAdminPageURL } from './Utils.js';

 class TermsandConditions extends React.Component{
    constructor() {
        super();
        this.state = {
            iFrameHeight: '0px',
            // channel : window.localStorage["channel"]
            channel : window.sessionStorage["channel"],
            isOem:false,
        }
    }

    handlebackbtn = () => {
        this.props.history.goBack(); 
    }

    componentDidMount() {
      this.setState({
        isOem: sessionStorage.getItem("channel") === 'OEMAPS1'
      })

    }
    render() {

        return (
            <div className="bg-white center">

           <nav
            className=" ph2 pv2 tr fixed top-0 left-0 right-0 shadow-4 z-999 "
            style={{ backgroundColor: "#032146" ,color:"#FFFDEA" }}
          >
            <div className="w-100  db center ">
              <div className="flex justify-start items-center" >
                <img fill="#ffffff"
                  className="w1"
                  src={navarrow}
                  alt="no available"
                  style={{width:"25px"}} onClick={()=>this.handlebackbtn()}/>
                <p className="f4-l f4 mv0 text-medium tc ml2">{REDEEM_INFO.REDEEM_INFO_TERMS_AND_CONDITIONS}</p>
              </div>
            </div>

          </nav>
         


                {/* <div className="ph2 ph6-l f6 f4-l f5-ns tc center bg-white" style={{ height:"100%",width:"100%",paddingTop: "3rem", overflow:"hidden"}} height="100%" width="100%"> */}
{(this.state.channel == "HPS" || this.state.channel == "hps" || this.state.channel == "A23HPS")? <div>
{/* pl-3827 */}
<iframe style={{ paddingTop: "3rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "scroll" }} height="100vh" width="100%"  title="" frameBorder="0px" overflowY="scroll" src={createOEMAdminPageURL(process.env.REACT_APP_PLAY_STATIC_WEB_URL, process.env.REACT_APP_OEMWEB_BASE_URL, "tandc.html?src=mapp&platformapp=Y&header=N",this.state.isOem)}>
                </iframe>
</div>: <div>
<iframe style={{ paddingTop: "3rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "scroll" }} height="100vh" width="100%"  title="" frameBorder="0px" overflowY="scroll" src={createOEMAdminPageURL(process.env.REACT_APP_REAL_STATIC_WEB_URL,process.env.REACT_APP_OEMWEB_BASE_URL,"termsandconditions.html?src=mapp&platformapp=Y&header=N",this.state.isOem)}>
                </iframe>
</div>}
                
                {/* </div> */}
            </div>

        );
    }
 }
 export default TermsandConditions;